// components/Composite/FeatureBlock/FeatureBlock.js
// NOTE: internals are tech debt — kept as-is until component is actively used.
// Outer section wrapper added for DOM Assembly compliance.
import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '../../Atoms';
import { RawHtml } from '../../Utilities';

const FeatureBlock = ({ value = {} }) => {
  const {
    heading,
    subheading,
    body,
    image,
    image_position = 'right',
    button_text,
    button_url,
    button_style = 'primary',
    button_position = 'below',
    background_color = 'white',
    text_color = 'dark',
  } = value;

  const getBgClasses = () => {
    const map = {
      white: 'bg-neutral-0',
      light: 'bg-neutral-50',
      dark: 'context-dark',
      primary: 'context-primary',
    };
    return map[background_color] || 'bg-neutral-0';
  };

  const getAlignmentClasses = () => {
    return text_color === 'light' ? 'on-dark' : '';
  };

  return (
    <section className={`section section-full ${getBgClasses()}`}>
      <div className="section__inner">
        <div className="section__body">
          <div className="block">
            <div className="block__body">
              <div className={`media-object ${image_position === 'left' ? 'media-object-reverse' : ''}`}>

                <div className={`media-object__body ${getAlignmentClasses()}`}>
                  <div className="content-element">
                    <div className="stack stack-normal">
                      {subheading && (
                        <div className="text-label">{subheading}</div>
                      )}
                      {heading && (
                        <div className="text-section-title">{heading}</div>
                      )}
                      {body && (
                        <div className="text-body">
                          <RawHtml html={body} />
                        </div>
                      )}
                      {button_text && button_url && button_position === 'inline' && (
                        <div className="cluster cluster-start">
                          <a href={button_url} className={`btn btn-${button_style}`}>
                            {button_text}
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {image && (
                  <div className="media-object__media">
                    <div className="media-element media-element-horizontal">
                      <Image image={image} fit="cover" />
                    </div>
                  </div>
                )}

              </div>

              {button_text && button_url && button_position === 'below' && (
                <div className="cluster cluster-center">
                  <a href={button_url} className={`btn btn-${button_style} btn-lg`}>
                    {button_text}
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

FeatureBlock.propTypes = {
  value: PropTypes.shape({
    heading: PropTypes.string,
    subheading: PropTypes.string,
    body: PropTypes.string,
    image: PropTypes.object,
    image_position: PropTypes.oneOf(['left', 'right']),
    button_text: PropTypes.string,
    button_url: PropTypes.string,
    button_style: PropTypes.string,
    button_position: PropTypes.oneOf(['inline', 'below']),
    background_color: PropTypes.oneOf(['white', 'light', 'dark', 'primary']),
    text_color: PropTypes.oneOf(['dark', 'light']),
  }),
};

export default FeatureBlock;